import { render, staticRenderFns } from "./OurPagination.vue?vue&type=template&id=b18237e2&"
import script from "./OurPagination.vue?vue&type=script&lang=js&"
export * from "./OurPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports